import {Link} from 'react-router-dom';
import Cars from '../constants/Cars';
import '../css/carviewer.scss';
import Box from '@mui/material/Box';

interface IProps {
  url: string;
  // id: string | undefined;
}

const CarViewer = ({url}:IProps) => (//) = ({lightId, lightName, lightComment} : Props) => (
  <Box className="car-viewer"
      sx={(theme) => ({
        '& a': {
          color: theme.palette.mode === 'dark' ? '#FFF' : '#000',
        },
      })}>
    <h1>Nos véhicules</h1>
    {
    <div className="cars-items content-width">
      {Cars.map((car) => { 
        return <div key={car.marque} className="car-item">
          <Link to={`${url}/${car.id}`}>
            <div className="car-item-encart">
              <img src={car.image} alt={car.imageAlt} className="vertical-center" />
            </div>
            <p>{car.marque}</p>
          </Link>
        </div> 
        })
      }
      </div>
    }
    {/* <Route path={`${url}/:id`} component={CarViewer} /> */}
  </Box>
);

export default CarViewer;
